export default {
    label_site_title:{
        en:"RND 2023",
        bn:"RND সফটওয়্যার"
    },
    label_welcome:{
        en:"Welcome",
        bn:"স্বাগতম"
    },
    label_dashboard:{
        en:"Dashboard",
        bn:"ড্যাশবোর্ড"
    },
    label_change_language:{
        en:"Change language",
        bn:"ভাষা পরিবর্তন"
    },
    label_en:{
        en:"English",
        bn:"English",
    },
    label_bn:{
        en:"বাংলা",
        bn:"বাংলা",
    },
    label_logout:{
        en:"Logout",
        bn:"লগআউট"
    },
    label_profile_settings:{
        en:"Profile Settings",
        bn:"প্রোফাইল সেটিংস"
    },
    label_action:{
        en:"Action",
        bn:"অ্যাকশন"
    },
    label_id:{
        en:"ID",
        bn:"আই.ডি."
    },
    label_name:{
        en:"Name",
        bn:"নাম"
    },
    label_ordering:{
        en:"Ordering",
        bn:"ক্রম"
    },
    label_status:{
        en:"Status",
        bn:"স্ট্যাটাস"
    },
    label_new:{
        en:"New",
        bn:'নতুন'
    },
    label_edit:{
        en:"Edit",
        bn:'সম্পাদনা'
    },
    label_details:{
        en:"Details",
        bn:'বিস্তারিত'
    },
    label_mobile_no:{
        en:"Mobile no.",
        bn:'মোবাইল নাম্বার'
    },
    label_email:{
        en:"Email",
        bn:'ইমেইল'
    },
    label_select:{
        en:"Select",
        bn:'সিলেক্ট'
    },
    label_created_at:{
        en:"Creation Time",
        bn:"তৈরির তারিখ"
    },
    label_updated_at:{
        en:"Updated Time",
        bn:"আপডেটের তারিখ"
    },
    label_address:{
        en:"Address",
        bn:"Address"
    },


    //for action and buttons both
    label_refresh:{
        en:'Refresh',
        bn:'রিফ্রেশ'
    },
    label_back:{
        en:'Back',
        bn:'পেছনে'
    },
    label_close:{
        en:'Close',
        bn:'বন্ধ করুন'
    },
    label_print:{
        en:'Print',
        bn:'ছাপান'
    },
    label_csv:{
        en:'CSV',
        bn:'সিএসভি'
    },
    label_download:{
        en:'Download',
        bn:'ডাউনলোড'
    },
    label_save:{
        en:'Save',
        bn:'সংরক্ষণ'
    },
    label_send:{
        en:'Send',
        bn:'পাঠান'
    },
    label_cancel:{
        en:'Cancel',
        bn:'বাতিল'
    },
    label_reset:{
        en:'Reset',
        bn:'রিসেট'
    },
    label_refresh_page:{
        en:'Refresh page',
        bn:'পেইজ রিফ্রেশ করুন'
    },
    label_back_home_page:{
        en:'Back Dashboard',
        bn:'ড্যাশবোর্ড যান'
    },
    label_column_control:{
        en:'Column Control',
        bn:'কলাম নিয়ন্ত্রণ'
    },
    label_save_column_controls:{
        en:'Save Column Controls',
        bn:'কলাম নিয়ন্ত্রণ সংরক্ষণ'
    },
    label_save_new:{
        en:'Save and New',
        bn:'সংরক্ষণ এবং নতুন'
    },
    label_upload_image:{
        en:'Select Image',
        bn:'ছবি নির্বাচন করুন'
    },
    label_upload_file:{
        en:'Select File',
        bn:'ফাইল নির্বাচন করুন'
    },
    label_add_more:{
        en:'Add More',
        bn:'আরো যোগ করুন'
    },
    //ColumnFilter start
    label_search:{
        en:"Search",
        bn:"অনুসন্ধান "
    },
    label_from:{
        en:"From",
        bn:"থেকে"
    },
    label_to:{
        en:"To",
        bn:"পর্যন্ত"
    },
    //ColumnFilter end
    //Pagination start
    label_per_page:{
        en:"Per Page",
        bn:"প্রতি পৃষ্ঠা "
    },
    label_go_page:{
        en:"Go to page",
        bn:"পৃষ্ঠায় যান "
    },
    label_all_items:{
        en:"All",
        bn:"সকল"
    },
    label_previous:{
        en:"Previous",
        bn:"পূর্ববর্তী "
    },
    label_next:{
        en:"Next",
        bn:"পরবর্তী "
    },
    label_showing:{
        en:"showing",
        bn:"দেখাচ্ছে"
    },
    //Pagination end
    label_year:{
        en:"Year",
        bn:"কর্মচারী আইডি"
    },
    label_trial_station :{
        en:"Trial Station",
        bn:"কর্মচারী আইডি"
    },
    label_season:{
        en:"Season",
        bn:"কর্মচারী আইডি"
    },
    label_rnd_code:{
        en:"RND Code",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_1:{
        en:"Jan",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_2:{
        en:"Feb",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_3:{
        en:"Mar",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_4:{
        en:"Apr",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_5:{
        en:"May",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_6:{
        en:"Jun",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_7:{
        en:"Jul",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_8:{
        en:"Aug",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_9:{
        en:"Sep",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_10:{
        en:"Oct",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_11:{
        en:"Nov",
        bn:"কর্মচারী আইডি"
    },
    label_month_short_12:{
        en:"Dec",
        bn:"কর্মচারী আইডি"
    },
}